import { PortableText, PortableTextProps } from '@portabletext/react'
import { Media, OrMedia, withAspectRatio } from '../or-media'

export interface OrContentBlockBProps {
  title: string
  paragraphOne: string
  content: PortableTextProps['value']
  footer: string
  mediaOne?: Media | null
  mediaTwo?: Media | null
}

export const OrContentBlockB = ({ title, paragraphOne, content, footer, mediaOne, mediaTwo }: OrContentBlockBProps) => {
  return (
    <section className="lg:max-w-screen-lg mx-auto pr-4 sm:pr-8 sm:pr-0 slg:px-12 lg:px-0 lg:pr-[10.4375rem]">
      <div className="slg:hidden">
        <div className="mb-8">
          <div className="h-1 w-12 bg-secondary-700" aria-hidden />
        </div>
        <div className="mb-2">
          <h2 className="text-neutrals-900 font-medium mb-4 text-24 font-heading leading-[1.95rem]">{title}</h2>
        </div>
        <div className="text-14 leading-1.5 text-neutrals-700 whitespace-pre-wrap font-regular mb-10">
          <p>{paragraphOne}</p>
        </div>
        <div className="text-14 leading-1.4 text-neutrals-700 font-regular mb-10">
          <PortableText
            value={content}
            components={{
              block: ({ children }) => {
                if (Array.isArray(children) && children.length === 1 && children[0] === '') {
                  return null
                }
                return <p className="mb-5 last:mb-0 leading-1.5 text-neutrals-700 whitespace-pre-wrap">{children}</p>
              },
            }}
          />
        </div>
        <div className="relative">
          <div className="w-[55%] sm:w-[56%] sm:max-w-[28rem]">
            {mediaOne && <OrMedia {...withAspectRatio(mediaOne, '3:4')} className="rounded-r-4 aspect-[3/4]" />}
          </div>
          {/*
            //VQA REF: studio-content-block-b-ml-images-mobile
            // TODO: remove when QA has completed their pass
          */}
          <div className="absolute top-[35%] w-[80%] right-[-1rem] sm:w-[89%] sm:max-w-[46rem] sm:top-[40%] sm:right-[-2rem]">
            {mediaTwo && (
              <OrMedia
                {...withAspectRatio(mediaTwo, '16:9')}
                className="rounded-4 relative left-[-20%] lg:left-[-10%] top-[20%] aspect-[16/9]"
              />
            )}
          </div>
          <div className="w-full bg-neutrals-100 p-4 pt-[5.625rem] sm:pt-[10.75rem] mt-[4.5rem] sm:pb-6">
            <p className="text-14 font-regular text-neutrals-700 leading-1.5">{footer}</p>
          </div>
        </div>
      </div>
      <div className="hidden slg:flex mb-8 lg:mb-10 gap-7.5">
        <div className="w-6/12 lg:w-7/12">
          <div className="mb-8">
            <div className="h-1 w-12 bg-secondary-700" />
          </div>
          <div className="mb-4">
            <h2 className="text-neutrals-900 font-medium text-32 font-heading leading-1.2">{title}</h2>
          </div>
        </div>
        <div className="w-6/12 lg:w-5/12">
          <div className="mb-8">
            <div className="h-1 w-12" />
          </div>
          <div className="text-16 leading-[1.313rem] text-neutrals-800 ">
            <p>{paragraphOne}</p>
          </div>
        </div>
      </div>
      {/*
        // VQA REF: studio-content-block-b
        // TODO: remove when QA has completed their pass
      */}
      <div className="hidden slg:flex slg:flex-col w-[100%]">
        <div className="relative w-full lg:pb-[4rem]">
          <div className="flex">
            <div className="w-6/12 lg:w-7/12">
              <div className="absolute z-10 left-[-3rem] h-[calc(100%+12rem)] w-max-[100%] min-h-[30rem] lg:h-[135%] lg:min-h-[38rem] lg:left-[-10.438rem]">
                {mediaOne && <OrMedia {...withAspectRatio(mediaOne, '3:4')} className="rounded-r-4 aspect-[3/4]" />}
              </div>
            </div>
            <div className="w-6/12 lg:w-5/12">
              <div className="pl-2">
                <PortableText
                  value={content}
                  components={{
                    block: ({ children }) => {
                      if (Array.isArray(children) && children.length === 1 && children[0] === '') {
                        return null
                      }
                      return <p className="mb-5 last:mb-0 leading-[1.313rem] text-neutrals-800">{children}</p>
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="bg-neutrals-100 flex relative right-[-8rem] lg:right-[-10.4375rem] min-h-[28rem] gap-7.5 mt-4 mb-16 mx-[5.219rem] py-[8rem] pr-8 lg:mt-0 lg:py-[8.75rem] lg:mx-0">
          <div className="w-6/12 z-20">
            <div className="w-[130%] max-w-[34rem] lg:w-[110%] lg:max-w-[52rem]">
              {mediaTwo && (
                <OrMedia
                  {...withAspectRatio(mediaTwo, '16:9')}
                  className="rounded-4 relative left-[-20%] lg:left-[-10%] top-[20%] aspect-[16/9]"
                />
              )}
            </div>
          </div>
          <div className="w-6/12 self-center pl-14 pr-8 lg:pl-12">
            <div className="text-16 leading-1.5 text-neutrals-800 font-regular py-auto">
              <p>{footer}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
